import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SSubCard, SWrapper } from './styles';
import { useApplicationByContactId } from 'core/api/applications';
import ApplicationList from 'components/Application/ApplicationList';
import Application from 'core/models/application';
import { SBoldPrimaryText } from 'styles/components';
import useResponsive from 'hooks/responsive';
import CardWithTitle from 'components/CardWithTitle';

type LinkedApplicationsProps = {
    contactId: string;
};

const LinkedApplications: FC<LinkedApplicationsProps> = ({ contactId }) => {
    const { t } = useTranslation();
    const { isMobile } = useResponsive();

    const { data: applicationsData } = useApplicationByContactId(contactId);
    const applications: Application[] = useMemo(() => applicationsData ?? [], [applicationsData]);

    if (!applications || !applications.length) {
        return null;
    }

    if (isMobile) {
        return (
            <>
                <SBoldPrimaryText>{t('common.applications')}</SBoldPrimaryText>
                <SSubCard>
                    <ApplicationList applicationsToDisplay={applications} truncate />
                </SSubCard>
            </>
        );
    } else {
        return (
            <SWrapper>
                <CardWithTitle label={t('common.applications')}>
                    <SSubCard>
                        <ApplicationList applicationsToDisplay={applications} truncate />
                    </SSubCard>
                </CardWithTitle>
            </SWrapper>
        );
    }
};

export default LinkedApplications;
